export function lerp(first: number, second: number, t: number): number {
    return first * (1 - t) + second * t;
}